import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";

class InboundFaxIndexingFormModel {
    public id: string = "";
    public source: string = "";
    public description: string = "";
    public notes: string = "";
    public documentDate: Date = null;
    public selectedSiteCode: string = "";
    public selectedResponsibleProviders: Person[] = [];
    public isUrgent: boolean = false;
    public selectedClassLookupId: Guid | string = GuidHelper.Empty();
    public selectedSubClassLookupId: Guid | string = GuidHelper.Empty();
    public selectedPatient: Person = null;
    public shouldAssignClassFaxNumber: boolean = false;
    public shouldAssignSourceFaxNumber: boolean = false;
    public isPatientFieldLocked: boolean = false;
    public isProvidersFieldLocked: boolean = false;
    public isDescriptionFieldLocked: boolean = false;
    public isSiteFieldLocked: boolean = false;
}

export { InboundFaxIndexingFormModel };
